// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c4n6","top":"styles_top__1_MKM","left":"styles_left__1z3wn","description":"styles_description__3lJ2Z"};